import { render, staticRenderFns } from "./editable.vue?vue&type=template&id=2df3362d&lang=pug&"
import script from "./editable.vue?vue&type=script&lang=js&"
export * from "./editable.vue?vue&type=script&lang=js&"
import style0 from "./editable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports